<template>
  <div class="home-header">
    <img class="home-bj" src="@/assets/img/images/home-bj.png" alt="home-bj" />
    <div class="bj-title-box">
      <!-- <p class="bj-title1">{{ number | formatNumber }}</p>
      <p class="bj-title2">注册用户</p> -->
      <p class="bj-title3">{{$t('home.header.title1')}}</p>
      <p class="bj-title4">{{$t('home.header.title2')}}</p>
      <div class="bj-btn c-flex-center" @click="$router.push('/register')" v-if="!jwtToken">
        {{$t('home.header.register_btn')}} <i class="el-icon-arrow-right" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      number: 1328012
    };
  },
  computed: {
    ...mapState(["jwtToken"]),
  },
  filters: {
    formatNumber(value) {
      if (!value && value !== 0) return ''
      return Number(value).toLocaleString('en-US')
    }
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.home-header {
  position: relative;
  width: 100%;
  height: 600px;
  background: #3f3f3f;
  .home-bj {
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 600px;
    object-fit: fill;
    position: absolute;
  }
  .bj-title-box {
    position: absolute;
    top: 120px;
    left: 290px;
    z-index: 1;
    .bj-title1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 90px;
      color: #4063ff;
    }
    .bj-title2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #4063ff;
    }
    .bj-title3 {
      margin-top: 24px;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 48px;
      color: #333333;
    }
    .bj-title4 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
    }
    .bj-btn {
      margin-top: 20px;
      width: 144px;
      height: 60px;
      cursor: pointer;
      font-family: PingFang SC, PingFang SC;
      font-weight: bold;
      font-size: 20px;
      color: #4063ff;
      background: #ffffff;
      border-radius: 12px 12px 12px 12px;
    }
  }
}
</style>
